import React, { useContext, useEffect, useState, useRef } from "react";
import { Col, Row, Button, InputGroup } from "react-bootstrap";
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Form from 'react-bootstrap/Form';
import '../styles.css';
import blogFetch from "../../../axios/config";
import Loading from "../../../components/Loading";
import toast from "react-hot-toast";
import language from "../../../nls/language.json"
import Context from "../../../context/Context";
import Pagination from '@mui/material/Pagination';
import ModalStatusMoldeFerramentaria from "./ModalStatusMoldeFerramentaria";
import { getCookie } from "../../../section/cookie";
import ModalHistoricPieces from "./ModalHistoricPieces";

function MoldTable() {

  const [editMode, setEditMode] = useState(null);
  const [molds, setMolds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState('');
  const [tempEdit, setTempEdit] = useState({})
  const { selectedCountry } = useContext(Context);
  const [show, setShow] = useState(false);
  const [item, setItem] = useState({});
  const [showHistoricPieces, setShowHistoricPieces] = useState(false);
  const [selectedMold, setSelectedMold] = useState({});

  const cookie = getCookie("permissions")
  const hasPermissionEditarMolde = cookie.includes("EditarMolds")
  const hasPermissionFerramentaria = cookie.includes("Botões Forno")
  const hasPermissionFerramentariaEdit = cookie.includes("Ferramantaria")
  const hasPermissionPassagemMaximaMold = cookie.includes("Passagem_Maxima_Mold")
  

  const debounceTimeout = 800;

  const list = async (skip, take, search) => {
    try {
      setLoading(true);
      const { data } = await blogFetch.get(`/ISAGA_Moldes/listMolds?search=${search}&skip=${skip}&take=${take}`);
      setMolds(data.molds);
      setTotalItems(data.totalItems);
    } catch {
      console.error("Error");
    } finally {
      setLoading(false);
    }
  };

  const timeoutRef = useRef(null);

  useEffect(() => {
    const skip = (currentPage - 1) * pageSize;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      list(skip, pageSize, search);
    }, debounceTimeout);

    // Limpeza ao desmontar
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [currentPage, search]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleSearch = () => {
    setCurrentPage(1);
  };

  const updateByStatus = async (params) => {
    setLoading(true)
    try {
      await blogFetch.put(`/ISAGA_Moldes`, params);
      toast.success("Molde atualizado com sucesso.", { duration: 4000 });
    } catch (error) {
      console.error(error);
      toast.error("Erro ao atualizar o molde.", { duration: 4000 });
    } finally {
      setLoading(false)
    }
  };

  const getIcon = (qtdPassagens, qtdPassagensMax) => {
    if (qtdPassagens >= qtdPassagensMax) {
      return <ErrorIcon className="red-icon" />;
    } else if (qtdPassagensMax - qtdPassagens <= 1) {
      return <WarningIcon className="yellow-icon" />;
    }
  };

  const handleConfirmed = async (data) => {
    const params = {
      molde_Key: data,
      molde_Status: "ESTOQUE",
    };
    const mold = molds.find((molde) => molde.molde_Key === data);
    if (mold.molde_QtdPassagens >= mold.molde_QtdPassagensMAX) {
      toast.error(`O molde ${mold.molde_Lote} atingiu o limite de passagens e não pode ter o status alterado sem a manutenção do Molde.`, {
        duration: 4000,
      });
    } else {
      await updateByStatus(params);
      setMolds((prevMolds) =>
        prevMolds.map((molde) =>
          molde.molde_Key === data ? { ...molde, molde_Status: "ESTOQUE" } : molde
        )
      );
    }
  };

  const toggleEditMode = (index) => {
    setEditMode((prevIndex) => (prevIndex === index ? null : index));
    setTempEdit((prevState) => {

      if (prevState.molde_Key !== molds[index]?.molde_Key) {

        return {
          molde_Key: molds[index]?.molde_Key,
          Molde_QtdPassagensMAX: molds[index]?.molde_QtdPassagensMAX,
          Molde_SAPLocal: molds[index]?.molde_SAPLocal,
        };
      }

      return prevState;
    });

  };

  const handleInputChange = (e, field) => {
    setTempEdit((prevState) => ({
      ...prevState,
      [field]: e.target.value,
    }));
  };

  const handleSaveEdit = async () => {
    const { molde_Key, Molde_QtdPassagensMAX, Molde_SAPLocal } = tempEdit;

    const params = { Molde_Key: molde_Key };

    if (Molde_QtdPassagensMAX) {
      params.Molde_QtdPassagensMAX = Molde_QtdPassagensMAX;
    }

    if (Molde_SAPLocal) {
      params.Molde_SAPLocal = Molde_SAPLocal;
    }

    try {
      await blogFetch.put(`/ISAGA_Moldes/updateMolde`, params);
      toast.success("Molde atualizado com sucesso.", { duration: 4000 });
      setEditMode(null);

      setMolds((prevMolds) =>
        prevMolds.map((molde) =>
          molde.molde_Key === molde_Key
            ? {
              ...molde,
              molde_QtdPassagensMAX: Molde_QtdPassagensMAX ?? molde.molde_QtdPassagensMAX,
              molde_SAPLocal: Molde_SAPLocal ?? molde.molde_SAPLocal,
            }
            : molde
        )
      );
    } catch (error) {
      console.error(error);
      toast.error("Erro ao atualizar o molde.", { duration: 4000 });
    }
  };


  const handleCancelEdit = () => {
    setEditMode(null);
    setTempEdit({})
  };

  return (
    <Row>
      <Col>
        <InputGroup className="my-5">
          <Form.Control
            placeholder="Buscar Molde - Código/Lote"
            value={search}
            onChange={handleSearchChange}
          />
          <Button className="status-molde-button-form" onClick={handleSearch}>
            Buscar
          </Button>
        </InputGroup>

        {!loading ?
          <>
            <table className="tableFixHead table text-center">
              <thead>
                <tr>
                  <th>CÓDIGO</th>
                  <th>LOTE</th>
                  <th>DESCRIÇÃO</th>
                  <th>QTD DE PASSAGENS</th>
                  <th>QTD DE PASSAGENS MAX</th>
                  <th>SAP LOCAL</th>
                  <th>STATUS</th>
                  <th>ESTOQUE</th>
                  {hasPermissionFerramentaria && <th>FERRAMENTARIA</th>}
                  {hasPermissionEditarMolde | hasPermissionPassagemMaximaMold && <th>EDITAR</th>}
                </tr>
              </thead>
              <tbody>
                {molds.map((item, index) => (
                  <tr key={index}>
                    <td>{item.molde_Codigo}</td>

                    <a onClick={() => {
                      setShowHistoricPieces(true)
                      setSelectedMold(item)
                    }}>
                      <td
                        style={{
                          color: "#0092ca",
                          cursor: "pointer"
                        }}>
                        {item.molde_Lote}
                      </td>
                    </a>

                    <td>{item.molde_Descricao}</td>
                    <td className="icon-cell">
                      {item.molde_QtdPassagens}
                      {getIcon(item.molde_QtdPassagens, item.molde_QtdPassagensMAX)}
                    </td>
                    <td>
                      <Form.Control
                        className="text-center"
                        value={
                          editMode === index
                            ? tempEdit.Molde_QtdPassagensMAX
                            : item.molde_QtdPassagensMAX
                        }
                        onChange={(e) => handleInputChange(e, 'Molde_QtdPassagensMAX')}
                        readOnly={!(editMode == index && hasPermissionPassagemMaximaMold)}
                      />
                    </td>
                    <td>
                      <Form.Control
                        className="text-center"
                        value={editMode === index ? tempEdit.Molde_SAPLocal : item.molde_SAPLocal}
                        onChange={(e) => handleInputChange(e, 'Molde_SAPLocal')}
                        readOnly={editMode !== index && hasPermissionEditarMolde}
                      />
                    </td>
                    <td>{item.molde_Status}</td>
                    <td>
                      <Button onClick={() => handleConfirmed(item.molde_Key)}>
                        ESTOQUE
                      </Button>
                    </td>
                    {hasPermissionFerramentaria && (
                      <>
                        <td>
                          <Button
                            disabled={item.molde_Status === "MANUTENCAO"}
                            onClick={() => {
                              setShow(true);
                              setItem(item);
                            }}
                          >
                            FERRAMENTARIA
                          </Button>
                        </td>
                      </>
                    )}

                    {hasPermissionEditarMolde |  hasPermissionPassagemMaximaMold && (
                      <td>
                        {editMode === index ? (
                          <>
                            <Button
                              onClick={handleCancelEdit}
                              variant="danger"
                              className="me-2"
                            >
                              CANCELAR
                            </Button>
                            <Button
                              onClick={handleSaveEdit}
                              variant="success"
                            >
                              SALVAR
                            </Button>
                          </>
                        ) : (
                          <Button
                            onClick={() => toggleEditMode(index)}
                            variant="primary"
                          >
                            EDITAR
                          </Button>
                        )}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination
              count={Math.ceil(totalItems / pageSize)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </>
          : (<Loading />)}
        <ModalStatusMoldeFerramentaria
          item={item}
          // selectedMotivo={selectedMotivo}
          // setSelectedMotivo={setSelectedMotivo}
          show={show}
          setShow={setShow}
          list={list}
        />
        <ModalHistoricPieces
          show={showHistoricPieces}
          setShow={setShowHistoricPieces}
          selectedMold={selectedMold}
        />
      </Col>
    </Row>
  );
}

export default MoldTable;